// Modules
import { Select } from "antd";
import styles from "components/atoms/SideNavInputSearch/SideNavInputSearch.module.css";
import theme from "styles/theme";

// Components
import ContainerDiv from "components/atoms/ContainerDiv/ContainerDiv";
import LinkItem from "components/atoms/LinkItem/LinkItem";
import Text from "components/atoms/Text/Text";

// Hooks
import { useSideNavInputSearch } from "components/atoms/SideNavInputSearch/useSideNavInputSearch";

// Constants & Utils
import getIcon from "utils/getIcon";
import { OutletItem } from "services/api/types";

// Type definitions
export type SideNavInputSearchProps = {
	placeholder?: string;
	outlets?: Array<OutletItem>;
};

const { Option } = Select;

const SideNavInputSearch = ({ placeholder, outlets }: SideNavInputSearchProps): JSX.Element => {
	const { searchInput, selectedValue, onSearch, onChange } = useSideNavInputSearch(outlets);

	// Format Option Value selected by user
	const optionValueArray: string[] = selectedValue.length ? selectedValue.split("*") : [outlets?.[0].outlet_name ?? "", outlets?.[0].outlet_code ?? ""];

	return (
		<>
			<ContainerDiv classes={styles.container} testid="input-search">
				<Select
					showSearch
					className={`left-nav-search ${styles.inputSearch}`}
					placeholder={placeholder}
					optionFilterProp="children"
					onChange={onChange}
					onSearch={onSearch}
					value={searchInput}
					style={{ width: 224 }}
					listHeight={325}
					popupClassName="left-nav-search-dropdown"
					dropdownStyle={{ backgroundColor: "#FAFBFC", boxShadow: "none" }}
					suffixIcon={<span className="cursor-pointer">{getIcon({ icon: "search" })}</span>}
					filterOption={(input, option) => (option?.value as unknown as string).toLowerCase().includes(input.toLowerCase())}
				>
					{outlets?.map((item) => {
						return (
							<Option value={`${item.outlet_name}*${item.outlet_code}`} key={item.outlet_code}>
								<LinkItem isInsideDropdown title={item.outlet_name} description={item.outlet_code} />
							</Option>
						);
					})}
				</Select>
			</ContainerDiv>
			<ContainerDiv classes={styles.dataDisplay}>
				<Text textContent={optionValueArray?.[0]} style={{ color: theme.colors.violet, fontWeight: 700, textAlign: "left" }} />
				<Text textContent={optionValueArray?.[1]} style={{ color: theme.colors.violet, fontWeight: 700, textAlign: "left" }} />
			</ContainerDiv>
		</>
	);
};

export default SideNavInputSearch;
